import React from "react";
import StatusIndicator from "./status";
import { Button, CopyValue } from "../..";
import { MdOutlineDragIndicator } from "react-icons/md";
import { FiArrowRight } from "react-icons/fi";
import { TbAlertTriangleFilled } from "react-icons/tb";
import { getReceiptReimbursementEligibility } from "../../../Utils/expenseReimbursement";

function ApprovalStatus({ draggable, showDragHint = false, status, id, categoryId, description, amount, date, merchant, attachments, violations, onAddToReimbursement }) {
	const { canAddToReimbursement, canShowAction, disabledReason } = getReceiptReimbursementEligibility({ status, categoryId, description, amount, date, merchant, attachments, violations });
	const helperText = showDragHint && canAddToReimbursement ? "Drag to reimbursement panel" : canShowAction && !canAddToReimbursement ? disabledReason : "";
	return (
		<div className={`px-3 py-2 bg-whitish border-t border-surface/60 ${draggable ? "cursor-move" : ""}`}>
			<div className="flex items-center justify-between gap-2">
				<div className="flex items-center gap-2 min-w-0">
					{draggable && <MdOutlineDragIndicator className="shrink-0" />}
					<CopyValue className="text-xxs truncate">RPT-{id}</CopyValue>
				</div>
				<div className="flex items-center gap-2 shrink-0">
					<StatusIndicator status={status} />
					{onAddToReimbursement && canShowAction ? (
						<Button onClick={onAddToReimbursement} disabled={!canAddToReimbursement} variant="primary" className="btn-xs gap-1">
							Move to Reimbursement <FiArrowRight />
						</Button>
					) : null}
				</div>
			</div>
			{helperText ? (
				<div className="mt-1">
					<div className="inline-flex items-center gap-1 rounded-md border border-danger/40 bg-danger/5 px-2 py-1 text-xxs text-dangerText max-w-full">
						<TbAlertTriangleFilled className="w-3 h-3 shrink-0" aria-hidden="true" />
						<span className="truncate">{helperText}</span>
					</div>
				</div>
			) : null}
		</div>
	);
}

export default ApprovalStatus;
